// @flow
import createIcon from './utils/createIcon'

export default createIcon({
  iconName: 'heart',
  icon: [
    14,
    12,
    null,
    null,
    'M6.687 11.972c-.273-.248-.535-.496-.807-.733-.765-.666-1.533-1.33-2.303-1.992-.628-.54-1.264-1.07-1.847-1.657-.45-.455-.858-.943-1.157-1.51-.244-.466-.4-.96-.483-1.477A6.857 6.857 0 0 1 .005 3.23C.061 1.835.933.64 2.262.207c1.423-.463 2.676-.14 3.75.873.248.233.454.5.635.785.01.017.022.033.04.06l.048-.075c.403-.624.921-1.128 1.596-1.468a3.484 3.484 0 0 1 1.872-.364c.862.067 1.606.39 2.21.998.514.515.812 1.137.92 1.848.065.439.041.879.003 1.318a5.289 5.289 0 0 1-.274 1.295c-.222.632-.581 1.184-1.023 1.688-.482.55-1.029 1.038-1.584 1.516-.824.71-1.654 1.413-2.475 2.126-.422.367-.83.748-1.245 1.123l-.048.042',
  ],
})
